// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3543":"488fc02e24eb8207","6185":"b6c5bfd9e0059e1f"}[chunkId] + ".js";
};